var option_webview_default = {
  "option": "gfHNW",
  "user_choice": "KCjBe",
  "check": "QDwjx",
  "image": "fJWit",
  "input": "LM08t",
  "title": "YcLJg",
  "centered": "dosfs",
  "with_result": "D7RWM",
  "list": "_1lVD3",
  "with_image": "a9OtF",
  "progress": "PX1V6",
  "progress_value": "aCfxd",
  "label": "miHrp",
  "cta": "vRXEH",
  "adornment_icon": "a87xp",
  "remove": "Ehdor",
  "removeButton": "_8-lJ3",
  "removeButtonIcon": "_5wUcW",
  "overlay": "AUxvl",
  "shown": "AXBnx",
  "dark": "l-G6-",
  "spinner": "lpoUN",
  "spin": "efc6U",
  "grid": "bi2Be"
};
export {
  option_webview_default as default
};
//# sourceMappingURL=option-webview-scss.js.map
